
import React, { useState } from "react";
import { Event } from "@/types";
import { parseISO } from "date-fns";
import CalendarView from "./calendar/CalendarView";
import EventSidebar from "./calendar/EventSidebar";
import EventDetailsDialog from "./calendar/EventDetailsDialog";

interface EventCalendarProps {
  events: Event[];
}

const EventCalendar = ({ events }: EventCalendarProps) => {
  const [selectedDate, setSelectedDate] = useState<Date | undefined>(new Date());
  const [selectedEvent, setSelectedEvent] = useState<Event | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  // Parse dates once to avoid repeated conversions
  const parsedEvents = events.map(event => {
    // Ensure we're correctly parsing ISO strings
    const parsedStartDate = parseISO(event.start_date);
    const parsedEndDate = parseISO(event.end_date);
    
    // Log for debugging
    console.log("Parsed event dates:", {
      id: event.id,
      title: event.title,
      startDate: parsedStartDate.toString(),
      endDate: parsedEndDate.toString()
    });
    
    return {
      ...event,
      parsedStartDate,
      parsedEndDate
    };
  });

  // Find events that occur on the selected date
  const eventsOnSelectedDate = selectedDate 
    ? parsedEvents.filter(event => {
        const checkDate = new Date(selectedDate);
        checkDate.setHours(0, 0, 0, 0);
        
        const eventStart = new Date(event.parsedStartDate);
        eventStart.setHours(0, 0, 0, 0);
        
        const eventEnd = new Date(event.parsedEndDate);
        eventEnd.setHours(23, 59, 59, 999);
        
        // Check if selectedDate is between start and end dates (inclusive)
        return checkDate >= eventStart && checkDate <= eventEnd;
      })
    : [];

  console.log("Events on selected date:", eventsOnSelectedDate.length);
  
  const handleEventClick = (event: Event) => {
    setSelectedEvent(event);
    setIsDialogOpen(true);
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="md:col-span-2">
          <CalendarView 
            selectedDate={selectedDate}
            onSelectDate={setSelectedDate}
            parsedEvents={parsedEvents}
          />
        </div>
        
        <div>
          <EventSidebar
            selectedDate={selectedDate}
            eventsOnSelectedDate={eventsOnSelectedDate}
            onEventClick={handleEventClick}
          />
        </div>
      </div>

      <EventDetailsDialog
        event={selectedEvent}
        isOpen={isDialogOpen}
        onOpenChange={setIsDialogOpen}
      />
    </div>
  );
};

export default EventCalendar;
